import * as ngCore from '@angular/core'
import * as store from '@attain-apps/fe/web/main/lib/store'

import { getActionsConfig } from './actions'
import * as effects from './effects'
import { Selectors } from './selectors'
import { State } from './state'

/**
 * A {@link store.Feature} that manages employee check-ins for Summit
 */
@ngCore.Injectable({ providedIn: 'root' })
export class Feature extends store.Feature<
  State,
  Selectors,
  ReturnType<typeof getActionsConfig>
> {
  constructor() {
    super({
      actions: getActionsConfig(),
      initialState: State.INITIAL,
      name: 'WritingHelper',
      selectors: () => new Selectors(this),
    })

    this.registerEffects(
      effects.registerNewActiveElement(),
      effects.loadEnhancement(),
      effects.startLoadingEnhancementWhenTypeIsFinalized(),
      effects.applyEnhancement(),
    )
  }
}
